import { movies, type Movie } from '@/mocks/movies';

export function getMovieById(id: number | string): Movie | undefined {
  const numeric = typeof id === 'string' ? Number(id) : id;
  return movies.find((movie) => movie.id === numeric);
}

export function getFeaturedMovies(): Movie[] {
  return movies.filter((movie) => movie.featured);
}

export function getRelatedMovies(current: Movie, limit = 4): Movie[] {
  const scored = movies
    .filter((movie) => movie.id !== current.id)
    .map((movie) => {
      const typeScore = movie.types.filter((type) => current.types.includes(type)).length * 2;
      const castScore = movie.cast.filter((name) => current.cast.includes(name)).length * 3;
      return { movie, score: typeScore + castScore };
    })
    .sort((a, b) => b.score - a.score || b.movie.heat - a.movie.heat);
  return scored.slice(0, limit).map((item) => item.movie);
}

export interface SortOption {
  value: 'updated' | 'heat' | 'rating';
  label: string;
}

export const sortOptions: SortOption[] = [
  { value: 'updated', label: '更新时间' },
  { value: 'heat', label: '热度' },
  { value: 'rating', label: '评分' },
];

export function sortMovies(list: Movie[], sort: SortOption['value']): Movie[] {
  const cloned = [...list];
  if (sort === 'heat') {
    return cloned.sort((a, b) => b.heat - a.heat);
  }
  if (sort === 'rating') {
    return cloned.sort((a, b) => b.rating - a.rating);
  }
  return cloned.sort((a, b) => b.year - a.year || b.id - a.id);
}

export function searchMovies(keyword: string): Movie[] {
  const key = keyword.trim().toLowerCase();
  if (!key) return [];
  return movies.filter((movie) => {
    return (
      movie.title.toLowerCase().includes(key) ||
      movie.types.some((type) => type.toLowerCase().includes(key)) ||
      movie.director.toLowerCase().includes(key) ||
      movie.cast.some((name) => name.toLowerCase().includes(key)) ||
      movie.summary.toLowerCase().includes(key) ||
      movie.region.toLowerCase().includes(key)
    );
  });
}

export function formatHeat(heat: number): string {
  if (heat >= 10000) {
    return `${(heat / 10000).toFixed(1)}万`;
  }
  return `${heat}`;
}

export const allMovies = movies;